import {Action, di} from "@dp-instant/core";
import {TypesCore, TypesFlow, IEventEmitter} from "@dp-instant/interfaces";
import {Button, UIEvents, useInjection} from "@dp-instant/ui";
import {CookieModelKey} from "@game/coregame/model/CookieModel";
import {GameModel} from "@game/coregame/model/GameModel";
import {TypesGame} from "@game/TypesGame";
import cn from "classnames";
import {useState} from "preact/hooks";
import {DebugPanel} from "./DebugPanel";
import "./DebugPopup.less";
import {DestroyFieldAction} from "@game/coregame/actions/DestroyFieldAction";

export const DebugPopup = () => {
    const [, changeState] = useState({});
    const model = useInjection<GameModel>(TypesGame.model);
    const close = () =>
        di.get<IEventEmitter>(TypesCore.dispatcher).emit(UIEvents.POPUP, {id: null});
    const clearCookies = () => {
        di.get(DestroyFieldAction).run();
        model.cookie.clear();
        model.currentContinent.buildings.clear();
        model.engine.removeAllEntities();
        di.get<Action>(TypesFlow.LevelStart).run();
        changeState({});
    };

    return (
        <div
            className="popups"
            style={{
                width: "100%",
                height: "100%",
                background: "rgba(black, 0.5)"
            }}
        >
            <div className={cn("debug-popup")}>
                <ul style={{color: "white"}}>
                    {Object.keys(CookieModelKey).map(k => (
                        <li>
                            {k}
                            &nbsp;
                            <b>{model.cookie["get"](k)}</b>
                        </li>
                    ))}
                </ul>
                <Button onClick={close}>Close</Button>
                <Button onClick={clearCookies}>Clear cookies</Button>
                <DebugPanel />
            </div>
        </div>
    );
};
